
export class GatePass {
  is_logged_in=false

  is_role_admin = false
  is_role_guardian = false
  is_role_student = false
  is_role_teacher = false
  is_member_of_marketing=false
  is_member_of_admin=false

  user_id=0
  username=""
}
